import React, { createContext, useContext } from 'react';
import { mobileAPI } from '../../api/MobileAPI';
const SwimmerAPIContext = createContext(mobileAPI);
export const SwimmerAPIProvider = ({ children }) => (React.createElement(SwimmerAPIContext.Provider, { value: mobileAPI }, children));
export const useSwimmerAPI = () => useContext(SwimmerAPIContext);
